<template>
  <div class="wrap" ref="workspaceWrap">  
    <input-nav></input-nav>
    <stage></stage>
  </div>
</template>

<script>
import { nextTick } from 'vue'
import InputNav from './Nav-Input.vue'
import Stage from './Stage.vue'
import html2canvas from 'html2canvas'
import EventBus from '../../../common/event-bus.js'

export default {
  components: {
    'stage': Stage,
    'input-nav': InputNav,
  },
  mounted() {
    EventBus.$on('captureWorkspace', () => {
      this.captureWorkspace()
    })
  },
  methods: {
    /**
     * Take a screen capture of the Workspace.
     * 
     * @see https://github.com/niklasvh/html2canvas
     */
    captureWorkspace() {
      nextTick(() => {
        // const workspace = this.$refs.workspaceWrap
        const workspace = document.getElementById('pricing-chart-panel')
        if (workspace) {

          workspace.style.pointerEvents = 'none'

          html2canvas(workspace, { width: 888, height: 372, logging: false, ignoreElements: (node) => node.tagName && node.tagName.toLowerCase() === 'button' })
            .then(canvas => {
              workspace.style.pointerEvents = 'auto'
              this.$store.dispatch('setViewCapture', canvas.toDataURL())
              EventBus.$emit('workspaceCaptured')
            })
            .catch(error => {
              workspace.style.pointerEvents = 'auto'
            })
        }
      })
    },
  }
}
</script>
